var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0.5 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1924_9759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66862 15.8334H16.3353C16.6072 15.8315 16.8745 15.7631 17.1139 15.6342C17.3533 15.5052 17.5576 15.3196 17.7088 15.0936C17.86 14.8676 17.9536 14.608 17.9815 14.3375C18.0093 14.067 17.9706 13.7938 17.8686 13.5418L11.9519 3.33343C11.8078 3.07293 11.5965 2.85579 11.3401 2.70458C11.0836 2.55338 10.7913 2.47363 10.4936 2.47363C10.1959 2.47363 9.90362 2.55338 9.64715 2.70458C9.39069 2.85579 9.17941 3.07293 9.03528 3.33343L3.11862 13.5418C3.01857 13.7881 2.97889 14.0547 3.00291 14.3195C3.02692 14.5843 3.11393 14.8395 3.25666 15.0638C3.39939 15.2881 3.59371 15.475 3.82339 15.6088C4.05307 15.7427 4.31144 15.8197 4.57695 15.8334",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66862 15.8334H16.3353C16.6072 15.8315 16.8745 15.7631 17.1139 15.6342C17.3533 15.5052 17.5576 15.3196 17.7088 15.0936C17.86 14.8676 17.9536 14.608 17.9815 14.3375C18.0093 14.0671 17.9706 13.7938 17.8686 13.5418L11.9519 3.33343C11.8078 3.07293 11.5965 2.85579 11.3401 2.70458C11.0836 2.55338 10.7913 2.47363 10.4936 2.47363C10.1959 2.47363 9.90362 2.55338 9.64715 2.70458C9.39069 2.85579 9.17941 3.07293 9.03528 3.33343L3.11862 13.5418C3.01857 13.7881 2.97889 14.0547 3.00291 14.3195C3.02692 14.5843 3.11393 14.8395 3.25666 15.0638C3.39939 15.2881 3.59371 15.475 3.82339 15.6088C4.05307 15.7427 4.31144 15.8197 4.57695 15.8334",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 12.5V12.5083M10.5 7.5V9.16667V7.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1924_9759"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.5e8bf351ef8d1d3e68edd0c740136fb6.svg";
export { ForwardRef as ReactComponent };